import React from "react";

import { GameInformationXboxNetworkDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ApplicationInformationXboxNetworkProps = {
  dataInForm: GameInformationXboxNetworkDataType;
};

const IdXboxXboxNetworkConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "xboxNetworkFeatures",
    {
      mapper: (data: GameInformationXboxNetworkDataType, localizedStrings: Map<string, string>) =>
        data.xboxNetworkFeatures.map(element => localizedStrings.get(element)),
    },
  ],
  [
    "addOns",
    {
      title: "anticipatedAddOnContent",
      mapper: (data: GameInformationXboxNetworkDataType, localizedStrings: Map<string, string>) =>
        data.addOns.map(element => localizedStrings.get(element)),
    },
  ],
  [
    "additionalContent",
    {
      title: "describeAdditionalContent",
    },
  ],
]);

export const ReadOnlyIdXboxXboxNetwork = ({
  dataInForm,
}: ApplicationInformationXboxNetworkProps) => {
  const extraStringsToLocalize = [
    "anticipatedFeatures",
    "sharedAchievements",
    "xboxPlayAnywhere",
    "xboxPlayAnywhereSubtitle",
    "crossOwnership",
    "crossSave",
    "crossProgression",
    "anticipatedAddOnContent",
    "addOns",
    "dlcPacks",
    "durables",
    "consumables",
    "freeAddOnContent",
    "describeAdditionalContent",
  ];

  return (
    <ReadOnlyForm
      formConfig={IdXboxXboxNetworkConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
